import React from 'react'
import { StyledBannersProps } from './types'
import styles from './Banners.module.scss'

export const StyledBanners: React.FC<StyledBannersProps> = ({ banners, className }) => {
  return (
    <div className={`grid gap-XS tablet:gap-M ${styles.banners} ${className || ''}`}>
      {banners.map(banner => (
        <a href={banner.href} id={banner.id} key={banner.src}>
          <img src={banner.src} alt={banner.alt} loading="lazy" className={styles.banner} />
        </a>
      ))}
    </div>
  );
}
